import { render, staticRenderFns } from "./ManageALFApprovers.vue?vue&type=template&id=8fdd4be6"
import script from "./ManageALFApprovers.vue?vue&type=script&lang=js"
export * from "./ManageALFApprovers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports